import { gsap } from 'gsap';
import { fadeInit, fadeEnter, fadeLeave } from '@/scripts/animations/fade';

export function loaderEnter(el) {
  const text = el.querySelector('.loader__text');
  const clouds = [...el.querySelectorAll('.loader__cloud img')];
  const tl = gsap.timeline();

  fadeInit(text, { y: 40 });
  clouds.forEach((cloud, i) => fadeInit(cloud, { x: `${(i % 2 === 0 ? -1 : 1) * 5}vw`, scale: 1.2 }));

  tl.addLabel('start')
    .add(fadeEnter(text), 'start')
    .add(fadeEnter(clouds, 0.1, 2.5), 'start+=0.5');

  return tl;
}

export function loaderLeave(el) {
  const bg = el.querySelector('.loader__bg');
  const text = el.querySelector('.loader__text');
  const clouds = [...el.querySelectorAll('.loader__cloud img')];
  const tl = gsap.timeline();

  tl.addLabel('start')
    .add(fadeLeave(clouds, { x: 0, y: -200, scale: 1.5 }, 0.05, 2.5), 'start')
    .add(fadeLeave(bg, {}, 1.5), 'start+=1')
    .add(fadeLeave(text, { y: 0, scale: 1.5 }, 0, 1.2), 'start+=0.2');

  return tl;
}
